import { Action } from '../../../util/analytics-data-attributes/analyticsAttributes'
import IconButton, { Variant } from '../../atoms/IconButton/IconButton'
import CancelSvg from '../../atoms/Icons/Button/Cancel'
import HamburgerSvg from '../../atoms/Icons/Button/Hamburger'
import UserSvg from '../../atoms/Icons/Button/User'
import Link from '../../atoms/Link/Link'
import { LogoLink, StyledDPGRLogo, Wrapper } from './MobileHeader.styles'

export type MobileHeaderProps = {
  className?: string
  menuIsOpen: boolean
  isLoggedIn: boolean
  accountUrl: string
  homeUrl: string
  onLogIn: () => void
  toggleMenu: (state?: boolean) => void
}

export const MobileHeader: React.FunctionComponent<MobileHeaderProps> = ({
  className,
  accountUrl,
  isLoggedIn,
  onLogIn,
  toggleMenu,
  homeUrl,
  menuIsOpen,
}) => {
  const menu = menuIsOpen ? <CancelSvg aria-label="Sluit menu" color="#FFFFFF" /> : <HamburgerSvg aria-label="Open menu" color="#FFFFFF" />

  return (
    <Wrapper className={className} data-testid="mobile-header">
      <IconButton label="Menu" variant={Variant.PrimaryBlack} onClick={() => toggleMenu(!menuIsOpen)}>
        {menu}
      </IconButton>
      <LogoLink href={homeUrl}>
        <StyledDPGRLogo color="white" />
      </LogoLink>
      {isLoggedIn ? (
        <Link dataAnalyticsAction={Action.clickOnAccount} dataAnalyticsLabel="header-dropdown" href={accountUrl}>
          <IconButton label="Account" variant={Variant.PrimaryBlack} onClick={() => toggleMenu(false)}>
            <UserSvg color="#FFFFFF" />
          </IconButton>
        </Link>
      ) : (
        <IconButton label="Inloggen" variant={Variant.PrimaryBlack} onClick={onLogIn}>
          <UserSvg color="#FFFFFF" />
        </IconButton>
      )}
    </Wrapper>
  )
}
